import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Plus,
  Upload,
  FileText,
  Heart,
  MoreVertical,
  FileCheck,
  FolderOpen,
} from "lucide-react";

interface PatientActionBarProps {
  hasActiveFilters: boolean;
  filterCount: number;
  onFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isUploading: boolean;
  onNewPatient: () => void;
  onHtmlUpload: () => void;
  onGoogleDriveImport: () => void;
  onCarePlanImport: () => void;
  onGenerateCarePlanPDFs: () => void;
  defaultPhoneNumberId: string | null;
}

const PatientActionBar = ({
  hasActiveFilters,
  filterCount,
  onFileUpload,
  isUploading,
  onNewPatient,
  onHtmlUpload,
  onGoogleDriveImport,
  onCarePlanImport,
  onGenerateCarePlanPDFs,
  defaultPhoneNumberId,
}: PatientActionBarProps) => {
  return (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-2">
        <h1 className="text-2xl font-bold">Patients</h1>
        <div className="flex gap-2">
          <input
            type="file"
            id="csv-upload"
            className="hidden"
            accept=".csv"
            onChange={onFileUpload}
            disabled={isUploading}
          />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" disabled={isUploading}>
                <MoreVertical className="h-4 w-4 mr-1" />
                Actions
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem
                onClick={() => document.getElementById("csv-upload")?.click()}
                disabled={isUploading}
              >
                <Upload className="h-4 w-4 mr-2" />
                {isUploading ? "Uploading..." : "Upload CSV"}
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={onCarePlanImport}
                disabled={isUploading}
              >
                <Heart className="h-4 w-4 mr-2" />
                Import Existing Care Plans
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={onGenerateCarePlanPDFs}
                disabled={isUploading}
              >
                <FileCheck className="h-4 w-4 mr-2" />
                Generate Missing Care Plan PDFs
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onHtmlUpload} disabled={isUploading}>
                <FileText className="h-4 w-4 mr-2" />
                Upload Patient Charts
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onGoogleDriveImport} disabled={isUploading}>
                <FolderOpen className="h-4 w-4 mr-2" />
                Import from Google Drive
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onNewPatient}>
                <Plus className="h-4 w-4 mr-2" />
                New Patient
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
};

export default PatientActionBar;
